var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4871 8.166C15.4871 12.2774 12.5023 16.1281 8.42457 17.2548C8.14711 17.3304 7.84442 17.3304 7.56696 17.2548C3.48921 16.1281 0.504465 12.2774 0.504465 8.166V4.47499C0.504465 3.78556 1.02576 3.00364 1.67315 2.743L6.35625 0.826061C7.40721 0.397266 8.59271 0.397266 9.64368 0.826061L14.3268 2.743C14.9658 3.00364 15.4955 3.78556 15.4955 4.47499L15.4871 8.166Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99622 9.32652C8.92492 9.32652 9.67777 8.57366 9.67777 7.64497C9.67777 6.71628 8.92492 5.96342 7.99622 5.96342C7.06753 5.96342 6.31467 6.71628 6.31467 7.64497C6.31467 8.57366 7.06753 9.32652 7.99622 9.32652Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99606 9.32619V11.8485",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.315fbbb7.svg";
export { ForwardRef as ReactComponent };